import { Chart } from '@frontend/chart/types';

export const TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Transactions',
            data: [
                { label: 'Acme Logistics', value: 1280 },
                { label: 'Riverside Hospital', value: 940 },
                { label: 'Northwind Retail', value: 730 },
                { label: 'Sunville City', value: 510 },
                { label: 'Dynamic Industries', value: 360 }
            ]
        }
    ]
};
